<template>
  <div class="flex flex-col gap-2.5">
    <div class="flex items-start justify-between gap-3 flex-wrap">
      <div class="flex items-center gap-2 min-w-0">
        <V4NoteAvatar :name="note?.author?.name" :size="compact ? 'sm' : 'md'" />
        <span class="text-sm font-semibold text-untitled-gray-800 truncate">
          {{ note?.author?.name }}
        </span>
      </div>
      <span class="text-xs text-untitled-gray-400 whitespace-nowrap">
        {{ formattedDate }}
      </span>
    </div>

    <div :class="compact ? '' : 'sm:pl-12'" class="flex flex-col gap-2">
      <span
        v-if="note?.unit?.name"
        class="inline-flex self-start items-center text-xs font-medium text-app-primary bg-app-primary/10 rounded-full px-2.5 py-0.5"
      >
        {{ note.unit.name }}
      </span>
      <p
        v-html="note?.value"
        class="text-sm text-untitled-gray-600 break-words leading-relaxed"
      />
    </div>

    <div
      v-if="$slots.actions"
      :class="compact ? '' : 'sm:pl-12'"
      class="flex items-center justify-between gap-2"
    >
      <slot name="meta" />
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import dayjs from "dayjs";
import V4NoteAvatar from "./V4NoteAvatar.vue";

const props = defineProps({
  note: {
    type: Object,
    default: null,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const formattedDate = computed(() => {
  return props.note?.created_at
    ? dayjs(props.note.created_at).format("MM/DD/YYYY")
    : "";
});
</script>
